import { DefaultService } from '@/services/DefaultService';

export default class VendasFaturamentoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    getFiltros() {
        return this._http.get(`${this._env}/report-sales/billing`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    saveFiltros(filtros) {
        return this._http.post(`${this._env}/report-sales/billing`, filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    getCSV(filtros) {
        return this._http.post(`${this._env}/report-sales/billing/csv`, filtros, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
    
}